import { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { mapVehicleModeToStopTypeName } from '../../../../utils/i18n';
import { StopFormState } from '../../../StopRegistry/Stops/Common/StopForm';
import { CustomOverlay } from '../../CustomOverlay';
import { MapModal } from '../../MapModal';
import { CreateChanges, EditChanges } from '../Types';
import { StopForm } from './Components/StopForm';

const testIds = {
  modal: 'EditStopModal',
};

type EditStopModalProps = {
  readonly defaultValues: Partial<StopFormState>;
  readonly editing: boolean;
  readonly onCancel: () => void;
  readonly onClose: () => void;
  readonly onSubmit: (changes: CreateChanges | EditChanges) => void;
};

export const EditStopModal: FC<EditStopModalProps> = ({
  defaultValues,
  editing,
  onCancel,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();

  const formRef = useRef<ExplicitAny>(null);

  const buildHeading = () => {
    const { publicCode: { value: label } = {}, vehicleMode } = defaultValues;

    const modeLabel = vehicleMode
      ? mapVehicleModeToStopTypeName(t, vehicleMode)
      : t(($) => $.stops.stop);

    return label
      ? t(($) => $.stops.stopWithLabel, {
          stopLabel: label,
        })
      : t(($) => $.stops.createStop, {
          vehicleModeTranslation: modeLabel,
        });
  };

  /**
   * No sure how or why, but container min-h-full + modal max-h-full + grid
   * stuff in global.css is the magic combo that makes stuff size corrently
   */

  return (
    <CustomOverlay
      className="min-h-full w-[calc(450px+(2*1.25rem))]"
      position="top-left"
    >
      <MapModal
        className="pointer-events-auto flex max-h-full flex-col"
        headerClassName="items-center px-4 py-4 *:text-xl"
        bodyClassName="mx-0 my-0 flex flex-col"
        testId={testIds.modal}
        onClose={onClose}
        heading={buildHeading()}
        navigationContext="StopForm"
      >
        <StopForm
          defaultValues={defaultValues}
          editing={editing}
          onSubmit={onSubmit}
          onCancel={onCancel}
          testIdPrefix={testIds.modal}
          ref={formRef}
          className="min-h-0"
        />
      </MapModal>
    </CustomOverlay>
  );
};
